﻿(() => {
  const MOBILE_QUERY = '(max-width: 989px)';
  const accordionSelectors = [
    '.mjr-policy-card',
    '.mjr-legal-card',
    '.mjr-page-card',
    '.mjr-page-hub__content-card',
    '.mjr-page-hub__faq-card',
    '.mjr-wholesale-resource'
  ].join(',');
  const navSelectors = `${accordionSelectors},.mjr-wholesale-process li`;

  const slugify = (value) => value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

  const chevron = () => {
    const span = document.createElement('span');
    span.className = 'mjr-accordion-trigger__icon';
    span.setAttribute('aria-hidden', 'true');
    span.innerHTML = '<svg viewBox="0 0 20 20" fill="none"><path d="m4.5 7.5 5.5 5 5.5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return span;
  };

  const setExpanded = (item, expanded, immediate = false) => {
    const trigger = item.querySelector('.mjr-accordion-trigger');
    const panel = item.querySelector('.mjr-accordion-panel');
    if (!trigger || !panel) return;
    trigger.setAttribute('aria-expanded', String(expanded));
    if (immediate) panel.style.transition = 'none';
    panel.classList.toggle('is-collapsed', !expanded);
    panel.setAttribute('aria-hidden', String(!expanded));
    if ('inert' in panel) panel.inert = !expanded;
    if (immediate) requestAnimationFrame(() => panel.style.removeProperty('transition'));
  };

  const isTermsPage = (root) => root?.classList.contains('mjr-legal-page--terminos-y-condiciones');

  const closeTermsMobileSelector = (root) => {
    const sidebar = root?.querySelector('.mjr-terms-sidebar');
    const toggle = root?.querySelector('[data-mjr-terms-mobile-toggle]');
    sidebar?.classList.remove('is-mobile-open');
    toggle?.setAttribute('aria-expanded', 'false');
  };

  const activateTermsPanel = (root, item, { scroll = false } = {}) => {
    if (!root || !item) return;
    const items = [...root.querySelectorAll('.mjr-internal-main .mjr-legal-card[data-mjr-accordion-ready="true"]')];
    if (!items.includes(item)) return;

    items.forEach((candidate) => {
      const active = candidate === item;
      candidate.hidden = !active;
      candidate.classList.toggle('is-mjr-terms-active', active);
      setExpanded(candidate, active, true);
    });

    root.querySelectorAll('[data-mjr-internal-nav] a').forEach((link) => {
      const active = link.getAttribute('href') === `#${item.id}`;
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });

    const activeHeading = item.querySelector(':scope > h2, :scope > h3, :scope > div > h2, :scope > div > h3');
    const mobileLabel = root.querySelector('[data-mjr-terms-mobile-label]');
    if (activeHeading && mobileLabel) mobileLabel.textContent = activeHeading.textContent.trim();
    closeTermsMobileSelector(root);

    if (!matchMedia(MOBILE_QUERY).matches) {
      root.querySelector('.mjr-terms-content')?.scrollTo({ top: 0, behavior: 'auto' });
    }

    if (window.location.hash !== `#${item.id}`) {
      history.replaceState(null, '', `${window.location.pathname}${window.location.search}#${item.id}`);
    }

    if (scroll) {
      requestAnimationFrame(() => {
        root.querySelector('.mjr-internal-main')?.scrollIntoView({
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    }
  };

  const collapseOtherItems = (item) => {
    const root = item.closest('[data-mjr-internal-page]');
    if (!root) return;
    const scope = item.matches('.mjr-page-hub__faq-card')
      ? item.closest('.mjr-page-hub__faq-section')
      : root;
    scope.querySelectorAll(accordionSelectors).forEach((candidate) => {
      if (candidate === item) return;
      const trigger = candidate.querySelector('.mjr-accordion-trigger');
      if (trigger?.getAttribute('aria-expanded') === 'true') setExpanded(candidate, false);
    });
  };

  const prepareItem = (item, index) => {
    if (item.dataset.mjrAccordionReady === 'true') return;
    if (item.dataset.mjrStaticLayout === 'true') return;
    const heading = item.querySelector(':scope > h2, :scope > h3, :scope > div > h2, :scope > div > h3');
    if (!heading) return;

    if (isTermsPage(item.closest('[data-mjr-internal-page]'))) {
      item.dataset.mjrAccordionReady = 'true';
      if (item.matches('.mjr-legal-card')) item.classList.add('mjr-is-tab-panel');
      if (!item.id) item.id = `informacion-${slugify(heading.textContent.trim()) || index + 1}`;
      return;
    }

    item.dataset.mjrAccordionReady = 'true';
    item.classList.add('mjr-is-collapsible');
    if (!item.id) item.id = `informacion-${slugify(heading.textContent.trim()) || index + 1}`;

    const trigger = document.createElement('button');
    const label = document.createElement('span');
    trigger.type = 'button';
    trigger.className = 'mjr-accordion-trigger';
    trigger.setAttribute('aria-controls', `${item.id}-panel`);
    label.textContent = heading.textContent.trim();
    trigger.append(label, chevron());
    heading.replaceChildren(trigger);

    const panel = document.createElement('div');
    const inner = document.createElement('div');
    panel.id = `${item.id}-panel`;
    panel.className = 'mjr-accordion-panel';
    inner.className = 'mjr-accordion-panel__inner';

    let node = heading.nextSibling;
    while (node) {
      const next = node.nextSibling;
      inner.appendChild(node);
      node = next;
    }
    panel.appendChild(inner);
    heading.parentElement === item ? item.appendChild(panel) : heading.parentElement.appendChild(panel);

    trigger.addEventListener('click', () => {
      const termsAccordion = item.closest('.mjr-legal-page--terminos-y-condiciones');
      const shippingFaq = item.matches('.mjr-page-hub--envios-y-despacho .mjr-page-hub__faq-card');
      if (termsAccordion) return;
      if (!matchMedia(MOBILE_QUERY).matches && !termsAccordion && !shippingFaq) return;
      const shouldExpand = trigger.getAttribute('aria-expanded') !== 'true';
      if (shouldExpand) collapseOtherItems(item);
      setExpanded(item, shouldExpand);
    });
  };

  const populateNav = (root) => {
    const nav = root.querySelector('[data-mjr-internal-nav]');
    if (!nav) return;
    const termsPage = root.classList.contains('mjr-legal-page--terminos-y-condiciones');
    const items = [...root.querySelectorAll(termsPage ? '.mjr-internal-main .mjr-legal-card' : navSelectors)].filter((item, index) => {
      const heading = item.querySelector(':scope > h2, :scope > h3, :scope > div > h2, :scope > div > h3');
      if (!heading || item.hasAttribute('data-mjr-skip-nav')) return false;
      if (!item.id) item.id = `informacion-${slugify(heading.textContent.trim()) || index + 1}`;
      return true;
    });
    if (termsPage) nav.replaceChildren();
    if (!nav.children.length) {
      items.forEach((item) => {
        const trigger = item.querySelector('.mjr-accordion-trigger');
        const heading = item.querySelector(':scope > h2, :scope > h3, :scope > div > h2, :scope > div > h3');
        const link = document.createElement('a');
        link.href = `#${item.id}`;
        link.textContent = trigger?.querySelector(':scope > span:first-child')?.textContent || heading.textContent.trim();
        link.addEventListener('click', (event) => {
          if (isTermsPage(root)) {
            event.preventDefault();
            activateTermsPanel(root, item, { scroll: matchMedia(MOBILE_QUERY).matches });
            return;
          }
          if (trigger && (matchMedia(MOBILE_QUERY).matches || termsPage)) setExpanded(item, true);
        });
        nav.appendChild(link);
      });
    }
    nav.hidden = nav.children.length === 0;
  };

  const bindTermsMobileSelector = (root) => {
    if (!isTermsPage(root) || root.dataset.mjrTermsMobileBound === 'true') return;
    const sidebar = root.querySelector('.mjr-terms-sidebar');
    const toggle = root.querySelector('[data-mjr-terms-mobile-toggle]');
    if (!sidebar || !toggle) return;
    root.dataset.mjrTermsMobileBound = 'true';

    toggle.addEventListener('click', () => {
      const open = !sidebar.classList.contains('is-mobile-open');
      sidebar.classList.toggle('is-mobile-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    });

    document.addEventListener('click', (event) => {
      if (!sidebar.classList.contains('is-mobile-open') || sidebar.contains(event.target)) return;
      closeTermsMobileSelector(root);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !sidebar.classList.contains('is-mobile-open')) return;
      closeTermsMobileSelector(root);
      toggle.focus({ preventScroll: true });
    });
  };

  const bindTermsNavigation = (root) => {
    if (!isTermsPage(root) || root.dataset.mjrTermsNavigationBound === 'true') return;
    root.dataset.mjrTermsNavigationBound = 'true';

    const activateFromEvent = (event) => {
      const link = event.target.closest?.('[data-mjr-internal-nav] a[href^="#"]');
      if (!link || !root.contains(link)) return;
      const id = decodeURIComponent(link.getAttribute('href').slice(1));
      const item = id ? root.querySelector(`#${CSS.escape(id)}`) : null;
      if (!item?.matches('.mjr-internal-main .mjr-legal-card')) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      activateTermsPanel(root, item, { scroll: matchMedia(MOBILE_QUERY).matches });
    };

    root.addEventListener('click', activateFromEvent, { capture: true });
  };

  const populateWholesaleSplitNav = () => {
    const roots = [...document.querySelectorAll('.mjr-wholesale-hub--split[data-mjr-internal-page]')];
    if (!roots.length) return;
    const nav = roots.map((root) => root.querySelector('[data-mjr-internal-nav]')).find(Boolean);
    if (!nav) return;

    const items = roots.flatMap((root) => [...root.querySelectorAll(navSelectors)]).filter((item, index) => {
      const heading = item.querySelector(':scope > h2, :scope > h3, :scope > div > h2, :scope > div > h3');
      if (!heading || item.hasAttribute('data-mjr-skip-nav')) return false;
      if (!item.id) item.id = `informacion-${slugify(heading.textContent.trim()) || index + 1}`;
      return true;
    });

    nav.replaceChildren();
    items.forEach((item) => {
      const trigger = item.querySelector('.mjr-accordion-trigger');
      const heading = item.querySelector(':scope > h2, :scope > h3, :scope > div > h2, :scope > div > h3');
      const link = document.createElement('a');
      link.href = `#${item.id}`;
      link.textContent = trigger?.querySelector(':scope > span:first-child')?.textContent || heading.textContent.trim();
      link.addEventListener('click', () => {
        if (trigger && matchMedia(MOBILE_QUERY).matches) setExpanded(item, true);
      });
      nav.appendChild(link);
    });
    nav.hidden = nav.children.length === 0;
  };

  const populatePageHubSplitNav = () => {
    const roots = [...document.querySelectorAll('.mjr-page-hub--split[data-mjr-internal-page]')];
    if (!roots.length) return;
    const nav = roots.map((root) => root.querySelector('[data-mjr-internal-nav]')).find(Boolean);
    if (!nav) return;

    const items = roots.flatMap((root) => [...root.querySelectorAll(navSelectors)]).filter((item, index) => {
      const heading = item.querySelector(':scope > h2, :scope > h3, :scope > div > h2, :scope > div > h3');
      if (!heading || item.hasAttribute('data-mjr-skip-nav')) return false;
      if (!item.id) item.id = `informacion-${slugify(heading.textContent.trim()) || index + 1}`;
      return true;
    });

    nav.replaceChildren();
    items.forEach((item) => {
      const trigger = item.querySelector('.mjr-accordion-trigger');
      const heading = item.querySelector(':scope > h2, :scope > h3, :scope > div > h2, :scope > div > h3');
      const link = document.createElement('a');
      link.href = `#${item.id}`;
      link.textContent = trigger?.querySelector(':scope > span:first-child')?.textContent || heading.textContent.trim();
      link.addEventListener('click', () => {
        if (trigger && matchMedia(MOBILE_QUERY).matches) setExpanded(item, true);
      });
      nav.appendChild(link);
    });
    nav.hidden = nav.children.length === 0;
  };

  const absorbLegacyNav = (root) => {
    const nav = root.querySelector('[data-mjr-internal-nav]');
    const legacy = root.querySelector('.mjr-internal-main > .mjr-legal-nav, .mjr-internal-main > article > .mjr-legal-nav');
    if (!nav || !legacy || legacy === nav) return;
    if (!nav.children.length) {
      [...legacy.querySelectorAll('a')].forEach((link) => nav.appendChild(link.cloneNode(true)));
    }
    legacy.remove();
  };

  const revealCurrentLegalTab = (root) => {
    const tabs = root.querySelector('.mjr-legal-tabs');
    const current = tabs?.querySelector('[aria-current="page"]');
    if (!tabs || !current) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (tabs.scrollWidth <= tabs.clientWidth) return;
        const centeredLeft = current.offsetLeft - ((tabs.clientWidth - current.offsetWidth) / 2);
        tabs.scrollTo({
          left: Math.max(0, Math.min(centeredLeft, tabs.scrollWidth - tabs.clientWidth)),
          behavior: 'auto'
        });
      });
    });
  };

  const splitRichContent = (root) => {
    const content = root.querySelector('[data-mjr-split-content]');
    if (!content || content.dataset.mjrSplitReady === 'true') return;

    const fragment = document.createDocumentFragment();
    let currentCard = null;
    let faqSection = null;
    let isFaq = false;

    [...content.childNodes].forEach((node) => {
      const isElement = node.nodeType === Node.ELEMENT_NODE;
      const tagName = isElement ? node.tagName : '';

      if (tagName === 'H2') {
        isFaq = /preguntas\s+frecuentes/i.test(node.textContent || '');
        currentCard = null;

        if (isFaq) {
          faqSection = document.createElement('section');
          faqSection.className = 'mjr-page-hub__faq-section';
          faqSection.appendChild(node);
          fragment.appendChild(faqSection);
        } else {
          faqSection = null;
          currentCard = document.createElement('article');
          currentCard.className = 'mjr-page-hub__content-card';
          currentCard.appendChild(node);
          fragment.appendChild(currentCard);
        }
        return;
      }

      if (isFaq && tagName === 'H3' && faqSection) {
        currentCard = document.createElement('article');
        currentCard.className = 'mjr-page-hub__faq-card';
        currentCard.setAttribute('data-mjr-skip-nav', '');
        currentCard.appendChild(node);
        faqSection.appendChild(currentCard);
        return;
      }

      if (currentCard) currentCard.appendChild(node);
      else if (faqSection && !(node.nodeType === Node.TEXT_NODE && !node.textContent.trim())) faqSection.appendChild(node);
    });

    content.replaceChildren(fragment);
    content.dataset.mjrSplitReady = 'true';
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-mjr-internal-page]').forEach((root) => {
      absorbLegacyNav(root);
      splitRichContent(root);
      const items = [...root.querySelectorAll(accordionSelectors)].filter((item) => !(
        root.classList.contains('mjr-wholesale-hub--support')
        && item.matches('.mjr-wholesale-resource')
      ));
      items.forEach(prepareItem);
      populateNav(root);
      bindTermsNavigation(root);
      bindTermsMobileSelector(root);
      revealCurrentLegalTab(root);

      const sync = () => {
        const termsPage = root.classList.contains('mjr-legal-page--terminos-y-condiciones');
        if (termsPage) {
          const termsItems = items.filter((item) => item.matches('.mjr-legal-card'));
          const hashItem = window.location.hash
            ? document.getElementById(window.location.hash.slice(1))
            : null;
          const current = termsItems.find((item) => item.classList.contains('is-mjr-terms-active'));
          activateTermsPanel(root, hashItem || current || termsItems[0]);
          return;
        }

        items.forEach((item, index) => {
          item.hidden = false;
          item.classList.remove('is-mjr-terms-active');
          const shippingFaq = item.matches('.mjr-page-hub--envios-y-despacho .mjr-page-hub__faq-card');
          if (shippingFaq) {
            const trigger = item.querySelector('.mjr-accordion-trigger');
            const expanded = trigger?.dataset.mjrUserExpanded === 'true';
            setExpanded(item, expanded, true);
          } else if (termsPage) {
            const trigger = item.querySelector('.mjr-accordion-trigger');
            const expanded = trigger?.dataset.mjrUserExpanded === 'true';
            setExpanded(item, expanded, true);
          } else if (matchMedia(MOBILE_QUERY).matches) {
            const trigger = item.querySelector('.mjr-accordion-trigger');
            const isSplitContinuation = root.classList.contains('mjr-page-hub--split-content');
            const expanded = trigger?.dataset.mjrUserExpanded === 'true' || (index === 0 && !isSplitContinuation);
            setExpanded(item, expanded, true);
          } else {
            setExpanded(item, true, true);
          }
        });
      };
      sync();

      if (root.dataset.mjrResponsiveBound !== 'true') {
        root.dataset.mjrResponsiveBound = 'true';
        const media = matchMedia(MOBILE_QUERY);
        media.addEventListener?.('change', sync);
        root.addEventListener('click', (event) => {
          const trigger = event.target.closest('.mjr-accordion-trigger');
          if (trigger) trigger.dataset.mjrUserExpanded = trigger.getAttribute('aria-expanded');
        });
      }
    });
    populateWholesaleSplitNav();
    populatePageHubSplitNav();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

